import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-collapsable-row',
  templateUrl: './collapsable-row.component.html',
  styleUrls: ['./collapsable-row.component.scss'],
  host: { class: 'apc-collapsable-row' },
})
export class CollapsableRowComponent implements OnInit {
  @Input() public subsection: string;
  @Input() public section: string;
  @Input() public index: number;
  @Input() public imgSrc: string;
  @Input() public imgSrcExp: string;
  @Input() public isExpired: string;
  @Input() public title: string;
  @Input() public isCollapsed: boolean;
  @Input() public isClosable: boolean = true;
  @Input() public titleIsUpperCase: boolean = false;
  @Input() public isModal: boolean = false;
  @Input() public isEdit: boolean = false;
  @Input() public blanketIsActive: boolean = false;
  @Output() collapseEvent = new EventEmitter<any>();

  public id: string = '';

  ngOnInit(): void {
    if (this.isModal) {
      this.id = this.section+'-'+this.subsection + '-modal-row-' + this.index;
    } else {
      this.id = this.section+'-'+this.subsection + '-row-' + this.index;
    }
  }

  collapse(e) {
    if (
      e.target.classList.contains('information') ||
      (e.target.parentElement && e.target.parentElement.classList.contains('information')) ||
      (e.target.parentElement &&
        e.target.parentElement.parentElement &&
        e.target.parentElement.parentElement.classList.contains('information'))
    ) {
      if (!this.isEdit) {
        if (this.isClosable) this.isCollapsed = true;
        this.collapseEvent.emit(this.collapseEvent);
      }
    }
  }

  collapseRow(e) {
    if (!this.isCollapsed && this.isClosable) this.isCollapsed = true;
    else this.isCollapsed = !this.isCollapsed;
    if(!this.isEdit) {
      this.collapseEvent.emit(this.collapseEvent);
      setTimeout(() => {
        document.getElementById(this.id).scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    } 
  }
}
